import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-objects-class-counter',
  slug: 'class-counter',
  title: 'A step counter with a private field',
  type: 'code',
  estSeconds: 420,
  contentVersion: 1,
});
